import { useMemo } from "react";

import { resolveGanttLayout } from "@/ds";
import { useMediaQuery } from "@/hooks";
import { conflitoLabel } from "@/modules/carga-trabalho";
import { SEM_MARCAS } from "@/modules/recursos/simulacao";

import { OBRAS_LAYOUT } from "../../gantt-obras-layout";
import { ganttScaleOf, monthMinWidth } from "@/shared/components/gantt-carga/gantt-scale";
import { CARGA_TRABALHO_MOBILE_QUERY } from "@/shared/components/gantt-carga/mobile";
import type { GanttLocalObrasProps, GanttLocalObrasViewModel } from "./types-gantt-local-obras";

export function useGanttLocalObras({
  rows,
  timeline,
  today,
  marcas = SEM_MARCAS,
}: GanttLocalObrasProps): GanttLocalObrasViewModel {
  const isMobile = useMediaQuery(CARGA_TRABALHO_MOBILE_QUERY);
  const scale = useMemo(() => ganttScaleOf(timeline), [timeline]);
  const { monthWidthRem, monthWidthMobileRem } = resolveGanttLayout(OBRAS_LAYOUT);

  return {
    rows,
    timeline,
    today,
    marcas,
    rotuloConflito: conflitoLabel,
    scale,
    monthWidthRem: isMobile ? monthWidthMobileRem : monthWidthRem,
    unitMinWidth: monthMinWidth(OBRAS_LAYOUT, isMobile),
  };
}
